import script from "./EditableInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditableInput.vue?vue&type=script&lang=ts&setup=true"

import "./EditableInput.vue?vue&type=style&index=0&id=65e2913c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65e2913c"]])

export default __exports__